import {State, Selector, Action, StateContext} from '@ngxs/store';
import { ValueProposition } from 'ng2-app/models/dto/value-proposition.model';
import { Injectable } from '@angular/core';
import { ValuePropositionsService } from 'ng2-app/services/value-propositions/value-propositions.service';
import { GetValuePropositions } from './value-proposition.actions';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';


export interface ValuePropositionStateModel {
  valuePropositions: ValueProposition[];
  loading: boolean;
  loaded: boolean;
}

@State<ValuePropositionStateModel>({
  name: 'ValueProposition',
  defaults: {
    valuePropositions: [],
    loading: false,
    loaded: false,
  }
})

@Injectable()

export class ValuePropositionState {
  @Selector()
  static valuePropositions(state: ValuePropositionStateModel): ValueProposition[] {
    return state.valuePropositions;
  }

  @Selector()
  static loading(state: ValuePropositionStateModel): boolean {
    return state.loading;
  }

  constructor(
    private valuePropositionsService: ValuePropositionsService,
  ) { }

  @Action(GetValuePropositions)
  getValuePropositions(
    { getState, patchState }: StateContext<ValuePropositionStateModel>,
    _: GetValuePropositions
  ) {
    // prevent unnecessary api calls
    const state = getState();
    if (state.loading || state.loaded) {
      return;
    }

    patchState({ loading: true });

    return this.valuePropositionsService.getValuePropositions().pipe(
      catchError(err => {
        patchState({ loading: false });
        return throwError(err);
      }),
      tap(results => {
        patchState({
          loading: false,
          loaded: true,
          valuePropositions: results
        });
      }),
    );
  }
}
